module.exports = __webpack_public_path__ + "img/monthly_report_graph.8c8babf1.svg";